/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

(function($) {

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Sage = {
// All pages
'common': {
  init: function() {
// JavaScript to be fired on all pages
},
finalize: function() {
// JavaScript to be fired on all pages, after page specific JS is fired


// $('.col-3.col-sm-2 > .navbar-toggler').click(function(){
//  $('.navbar-toggler > .img-fluid').toggleClass("d-none");  
//  $('#bs-example-navbar-collapse-1').toggle();
// });


// begin disabled the 'enter' keyboard on search
jQuery('.banner .form-control.aa-input').keypress(
  function(event){
    if (event.which == '13') {
      event.preventDefault();
    }
  });
// end disabled search 'enter' 


// var mq = window.matchMedia('(max-width: 767px)');
// if (mq.matches) {
//  $(".dropdown-toggle").attr('data-toggle', 'dropdown');

// } else {
//   $("#menu-item-dropdown-1088").click(function(e){
//    e.preventDefault();
//    window.location = "/articles/";    
//  });

//   $("#menu-item-dropdown-1377").click(function(e){
//    e.preventDefault();
//    window.location = "/recipes/";    
//  });
// }

// begin main menu - megamenu
$(".parent-trigger").mouseover(function () {
  if ($(this).attr('aria-expanded') == 'false' ) {
        // do this
        $('body').addClass('is-visible');
        $('.site-header').addClass('dropdown-visible');
        $('#blog-meganav').slideDown('fast').css('opacity','1');

        $(this).addClass('nav-visible');
        // $("#recipes-meganav").slideUp("fast");
        $('#recipes-meganav').hide().css('opacity','0');
        $(".recipes-trigger").removeClass('nav-visible');
        $('.PageOverlay').remove();
        $('body').append( "<div class='PageOverlay'></div>" );
      }

    });


// begin hover tabs megamenu
$('#blog-meganav .menu-col .flex-column > li > a, #recipes-meganav .menu-col .flex-column > li > a').hover(function() {
  $(this).tab('show');
});
// end hover tabs megamenu

// begin click on tabs
$("#blog-meganav .nav-item .nav-link, #recipes-meganav .nav-item .nav-link").click(function () {
  var grabLink = $(this).attr("href");
  location.href = grabLink;
});
/*end click on tabs*/

$(".recipes-trigger").mouseover(function () {

  if ($(this).attr('aria-expanded') == 'false' ) {
        // do this
        // $('.site-header').addClass('dropdown-visible');
        $('body').addClass('is-visible');
        $("#recipes-meganav").slideDown('fast').css('opacity','1');
        $(this).addClass('nav-visible');
        $("#blog-meganav").hide().css('opacity','0').removeClass('nav-visible');
        $(".parent-trigger").removeClass('nav-visible');
        // $(".site-header__search-toggle").removeClass('nav-visible');
        $('.PageOverlay').remove();
        $('body').append( "<div class='PageOverlay'></div>" );

      }

    });

$("#blog-meganav").mouseover(function () {
  $(".parent-trigger").attr('aria-expanded', 'true');
  // $('.site-header').addClass('dropdown-visible');
  $(this).addClass('nav-visible').show();
  $(".parent-trigger").removeClass('nav-visible');
  $('body').addClass('is-visible');
  $('.PageOverlay').remove();
  $('body').append( "<div class='PageOverlay'></div>" );
});

$("#recipes-meganav").mouseover(function () {
  $(".recipes-trigger").attr('aria-expanded', 'true');
  // $('.site-header').addClass('dropdown-visible');
  $(this).addClass('nav-visible').show();
  $(".recipes-trigger").removeClass('nav-visible');
  $('body').addClass('is-visible');
  $('.PageOverlay').remove();
  $('body').append( "<div class='PageOverlay'></div>" );
});

$(".mega-nav").mouseout(function () {
  // $('.site-header').removeClass('dropdown-visible');
  $(this).hide();
  $(".parent-trigger").removeClass('nav-visible').attr('aria-expanded', 'false');
  $(".recipes-trigger").removeClass('nav-visible').attr('aria-expanded', 'false');
  $(this).removeClass('nav-visible');
  $('.PageOverlay').remove();
  $('body').removeClass('is-visible');
});

$(".no-meganav, .top-nav, .navbar-search").mouseover(function () {
  $('.PageOverlay').remove();
  $('body').removeClass('is-visible');

  $(".parent-trigger, .recipes-trigger").removeClass('nav-visible');
  $("#recipes-meganav, #blog-meganav").slideUp('fast');
});
// end main menu - megamenu


// begin mobile menu
$('.mobile-slide-wrap').click(function(e) {
  e.preventDefault();

  if ($(this).hasClass('menu-opened')) {
    $('.mobile-menu').fadeOut('medium');
    $(this).removeClass('menu-opened');
      // $('body').css('overflow', 'auto');
      $('body').removeClass('is-active');
      $('.site-header').removeClass('menu-opened');
    } else {
      // $("#search-navbar").hide().css('opacity','0').removeClass('nav-visile');
      $('.mobile-menu').fadeIn('medium');
      $(this).addClass('menu-opened');
      // $('body').css('overflow', 'hidden');
      $('body').addClass('is-active');
      // $('.site-header').removeClass('dropdown-visible').addClass('menu-opened');
    }
  });

var xsMenuPanels = $('#mhome ul li.has-menu .minnermenu').hide();

$('#mhome ul li.has-menu >a').click(function(e) {
  e.preventDefault();

  $("#mhome > ul > li.has-menu").removeClass("active");
  $("#mhome ul li.has-menu .minnermenu").slideUp('medium');

  if (!$(this).next().is(":visible")) {
    $(this).next().slideDown('slow');
    $(this).parent("li").addClass("active");

  }else{
    $(this).next().slideUp('slow');
      // $(this).find('span.glyphicon-plus').addClass('glyphicon-active');
      $(this).parent("li").removeClass("active");
    }
    return false;
  });
// end mobile menu

}
},
'home': {
  init: function() {

    $(".header").click(function () {

      $header = $(this);
//getting the next element
$content = $('#middle .one.content.col-md-12, #middle .one.col-md-12'); 
//open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
$content.slideToggle(500, function () {
//execute this after slideToggle is done
//change text of header based on visibility of content div
$header.html(function () {
//change text based on condition
return $content.is(":visible") ? "<div class='row'><div class='col-md-3 col-lg-5 col-3 text-center'><span>Hide</span></div><div class='col-md-9 col-lg-7 col-9 no-padding'><h2>Featured Keto Recipes</h2></div></div>" : "<div class='row'><div class='col-md-3 col-lg-5 col-3 text-center'><span>Show</span></div><div class='col-md-9 col-lg-7 col-9 no-padding'><h2>Featured Keto Recipes</h2></div></div>";
});
});
});    

    $(".header2").click(function () {

      $header = $(this);
//getting the next element
$content = $('#middle .two.content.col-md-12, #middle .two.col-md-12'); 
//open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
$content.slideToggle(500, function () {
//execute this after slideToggle is done
//change text of header based on visibility of content div
$header.html(function () {
//change text based on condition
return $content.is(":visible") ? "<div class='row'><div class='col-md-3 col-lg-5 col-3 text-center'><span>Hide</span></div><div class='col-md-9 col-lg-7 col-9 no-padding'><h2>Featured Keto Guides&nbsp;</h2></div></div>" : "<div class='row'><div class='col-md-3 col-lg-5 col-3 text-center'><span>Show</span></div><div class='col-md-9 col-lg-7 col-9 no-padding'><h2>Featured Keto Guides&nbsp;</h2></div></div>";
});
});
});


  },
  finalize: function() {

    /*begin slick slider*/
    var $jq = jQuery.noConflict();

    $jq('.preview-carousel').slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay:true,
      autoplaySpeed:2000,
      arrows: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      ]
    });      

    $jq('.ebooks').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay:false,
      autoplaySpeed:2000,
      arrows: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      }
      ]
    });

    $jq('.authors-carousel').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay:false,
      autoplaySpeed:2000,
      arrows: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
      ]
    });
    /*end slick slider*/

  }
}, 

'single_recipescentre': {
  init: function() {
    $('#box-entry a, #rate-recipe, #bg-middle .badge-danger').on('click', function () {
var target = this.hash, // gets the href of the <a>
$target = $(target); // puts it as a selector
$('html, body').stop().animate({
'scrollTop': $target.offset().top // scrolls to the top of the element clicked on
}, 900, 'swing', function () {
  window.location.hash = target;
});
});
  },
  finalize: function() {
    var begin_title = "Serving of ";
    var page_title = document.getElementById("page_title").innerHTML;
    var field_calories = document.getElementById("field_calories").value;
    var field_TotalFat = document.getElementById("field_TotalFat").value;
    var field_SatFat = document.getElementById("field_SatFat").value;
    var field_Cholesterol = document.getElementById("field_Cholesterol").value;
    var field_Sodium = document.getElementById("field_Sodium").value;
    var field_TotalCarb = document.getElementById("field_TotalCarb").value;
    var field_Fibers = document.getElementById("field_Fibers").value;  
    var field_Sugars = document.getElementById("field_Sugars").value;  
    var field_Proteins = document.getElementById("field_Proteins").value;

    $('#nutrition-label').nutritionLabel({
      itemName : begin_title.concat(page_title),
      showPolyFat : false,
      showMonoFat : false,
      showServingUnitQuantity : false,
      showIngredients : false,
      showTransFat : false,
      showAddedSugars : false,
      showFatCalories : false,
      showLegacyVersion : false,
      showVitaminD : false,
      showCalcium : false,
      showIron : false,
      showPotassium_2018  : false,
      showCaffeine : false,
      decimalPlacesForQuantityTextbox : 2,
      valueServingUnitQuantity : 1,
      allowFDARounding : false,
      decimalPlacesForNutrition : 2,
      valueCalories : field_calories,
      valueTotalFat : field_TotalFat,
      valueSatFat : field_SatFat,
      valueCholesterol : field_Cholesterol,
      valueSodium : field_Sodium,
      valueTotalCarb : field_TotalCarb,
      valueFibers : field_Fibers,
      valueSugars : field_Sugars,
      valueProteins : field_Proteins
    });

  }
},

// 'post_type_archive_recipescentre': {
//   init: function() {

//     $(function($){
//       $('#filter').change(function(){
//         var filter = $('#filter');
//         $.ajax({
//           url:filter.attr('action'),
// data:filter.serialize(), // form data
// type:filter.attr('method'), // POST
// beforeSend:function(xhr){
// filter.find('button').text('Processing...'); // changing the button label
// },
// success:function(data){
// filter.find('button').text('Apply filter'); // changing the button label back
// $('#response').html(data); // insert data

// }
// });
//         return false;
//       });
//     });

//   }

// },

'single_keto_articles': {
  init: function() {
// begin scrols Js to different sections
$('a[href="reference1"], a[href="reference2"], a[href*="section"]').on('click', function (e) {
e.preventDefault(); // prevents default action of <a>

var target = this.hash, // gets the href of the <a>
$target = $(target); // puts it as a selector
console.log($target);
$('html, body').stop().animate({
'scrollTop': $target.offset().top // scrolls to the top of the element clicked on
}, 900, 'swing', function () {
  window.location.hash = target;
});
});
// end scrols Js to different sections

var sidebar = new StickySidebar('#sidebar', {
  containerSelector: '.entry-content',
  innerWrapperSelector: '.box',
  topSpacing: 0,
  bottomSpacing: 0
});
}
},

'keto_faq': {
  init: function() {

//disable prevent enter 
jQuery('.search-autocomplete').keypress(
  function(event){
    if (event.which == '13') {
      event.preventDefault();
    }
  });

 jQuery('#gform_fields_4').addClass('row');

/*begin custom code grab value from URL */
// https://www.sitepoint.com/get-url-parameters-with-javascript/
jQuery(document).ready(function($) {



  if( jQuery('.search-autocomplete' != null)){
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var search = urlParams.get('search');

 result = search.toLowerCase()        //converts a string to lowercase letters
                .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
                .replace(/-+/g, '-') // collapse dashes
                .replace('?', ''); //remove ? from string

                var element = document.getElementById(result);
                element.scrollIntoView();
                // jQuery(element).find('.collapse').removeClass('collapse'); 
                jQuery(element).find('.collapsed').trigger( "click" );
              }
            });
}
},

'keto_calculator': {
  init: function() {

    /*begin sticky nav*/
    var sidebar = new StickySidebar('#affix', {
      containerSelector: '.scrollspy-example',
      innerWrapperSelector: '#kiss-navbar',
      topSpacing: 0,
      bottomSpacing: 0
    });
    /*end sticky nav*/
    $('#navbar-example a, .badge').on('click', function () {
var target = this.hash, // gets the href of the <a>
$target = $(target); // puts it as a selector
console.log($target);
jQuery('html, body').stop().animate({
'scrollTop': $target.offset().top // scrolls to the top of the element clicked on
}, 900, 'swing', function () {
  window.location.hash = target;
});
});

    /*begin custom.js from Shopify page*/
// BEGIN CALCULATOR PAGE
// display the current value from range slider
var slider = document.getElementById("formControlRange"),
output = document.getElementById("rangeVal"),
label = document.querySelector(".range-label"),
subtitle = document.querySelector("#range-subtitle");

if(typeof(slider) != 'undefined' && slider != null){
  output.innerHTML = slider.value;

  slider.oninput = function() {
//range value
output.innerHTML = this.value;

//range label
if (this.value >0) {
  label.innerHTML="Surplus";
}else if (this.value == 0){
  label.innerHTML="No change";
}else{
  label.innerHTML="Deficit";
}

//range subtitle
if (this.value >0 && this.value <= 15){
  subtitle.innerHTML="This is a balanced calorie intake";
}else if (this.value < 0 && this.value >= -30 ){
  subtitle.innerHTML="This is a balanced calorie deficit";
}else if (this.value <= -35 && this.value >= -40 ){
  subtitle.innerHTML="This is a risky calorie deficit";
}else if (this.value >= 35 && this.value <= 40 ){
  subtitle.innerHTML="This is a risky calorie intake";
}else if (this.value < -40 && this.value >= -50 ){
  subtitle.innerHTML="This is an extremely risky calorie deficit. It can lead to metabolic damage in the long run.";
}else if (this.value >= 45 && this.value <= 50 ){
  subtitle.innerHTML="This is an extremely risky calorie intake. It can lead to metabolic damage in the long run.";
}else if (this.value == 0){
  subtitle.innerHTML="This is a balanced calorie intake";
}else{
}

}

//display the current value from range slider

// activities select
var activitiesOptions = document.getElementsByClassName('activities-dropdown-option'),
xsActivOptions = document.getElementsByClassName('mobile-activities-variant-options')[0],
activitiesVariant = document.getElementsByClassName('activities-selected-variant')[0],
activitiesContainer = document.getElementsByClassName('activities-variant-options')[0];

if( activitiesOptions.length > 0 ) {
  for(var i = 0; i < activitiesOptions.length; i++) {
    (function(i){

      function activitiesValues() {
        var variantClass = 'variant-'+activitiesOptions[i].getAttribute('data-label'),
        variant = document.getElementsByClassName(variantClass)[0],
        activScore = variant.getAttribute('active-score'),
        variantText = variant.getAttribute('data-text');

        document.querySelector('#activities').value = activScore;
        document.querySelector('.activities-selected-variant .variant-description').innerHTML = variantText;
        document.querySelector('.activities-dropdown-container').classList.add('valid');
        activitiesContainer.classList.remove("dropdown-open");
        xsActivOptions.classList.remove("xs-dropdown-open");
      }
      activitiesOptions[i].addEventListener('click', activitiesValues);
    })(i);
  }
}

function classToggle() {
  activitiesContainer.classList.toggle("dropdown-open");
  xsActivOptions.classList.toggle("xs-dropdown-open");
}
activitiesVariant.addEventListener('click', classToggle);
// activities select

// excercise select
var excerciseOptions = document.getElementsByClassName('excercise-dropdown-option'),
xsExerciseOptions = document.getElementsByClassName('mobile-excercise-variant-options')[0],
excerciseVariant = document.getElementsByClassName('excercise-selected-variant')[0],
excerciseContainer = document.getElementsByClassName('excercise-variant-options')[0];

if( excerciseOptions.length > 0 ) {
  for(var i = 0; i < excerciseOptions.length; i++) {
    (function(i){

      function excerciseValues() {
        var exerciseClass = 'exercise-variant-'+excerciseOptions[i].getAttribute('data-label'),
        exerciseVariant = document.getElementsByClassName(exerciseClass)[0],
        exercScore = exerciseVariant.getAttribute('exerc-score'),
        exerciseVariantText = exerciseVariant.getAttribute('data-text');

        document.querySelector('#exercise').value = exercScore;
        document.querySelector('.excercise-selected-variant .variant-description').innerHTML = exerciseVariantText;
        document.querySelector('.exercise-dropdown-container').classList.add('valid');
        excerciseContainer.classList.remove("dropdown-open");
        xsExerciseOptions.classList.remove("xs-dropdown-open");
      }
      excerciseOptions[i].addEventListener('click', excerciseValues);
    })(i);
  }
}

function exerciseToggle() {
  excerciseContainer.classList.toggle("dropdown-open");
  xsExerciseOptions.classList.toggle("xs-dropdown-open");
}
excerciseVariant.addEventListener('click', exerciseToggle);
}
// excercise select

jQuery(function($) {
  var cdr_name = '';
  var height = 0;
  var weight = 0;
  var weight_lbs = 0;
  var formula = null;
  var leanMass = 0;
  var leanMass_lbs = 0;
  var heightInputM = $('#cmsheightvalue');
  var heightInputF = $('#heightvalue');
  var heightInputI = $('#heightinvalue');

  $('#cm-step-2 .cm-macro-disable').height($('#cm-step-2').height() + 40);
  $('#cm-step-2 .cm-macro-disable').width($('#cm-step-2').width() + 40);
  $('#cm-step-3 .cm-macro-disable').height($('#cm-step-3').height() + 40);
  $('#cm-step-3 .cm-macro-disable').width($('#cm-step-3').width() + 40);
  $('#cm-step-4 .cm-macro-disable').height($('#cm-step-4').height() + 40);
  $('#cm-step-4 .cm-macro-disable').width($('#cm-step-4').width() + 40);

  $('#optMS').change(function() {
// $('#txtBF').slideUp(); //prop('disabled', true);
$('#txtBF').hide();
$('#mass-label').removeClass('active');
$('#athletes-label').addClass('active');
});
  $('#optLM').change(function() {
// $('#txtBF').slideDown(); //prop('disabled', false);
$('#txtBF').show();
$('#mass-label').addClass('active');
$('#athletes-label').removeClass('active');
});

  $('input[name=\'cm-system\']').change(function() {
    var weightInput = $('#weightvalue');
    var weightValue = parseInt(weightInput.val());

    if ($('input[name=\'cm-system\']:checked').val() === 'metric') {

      $('#heightfit').hide();
      $('#heightcms').show();
      $('#weightmeasure').html('kgs');
      $('#cm-system-wrapper .btn-primary').toggleClass('active');

      var cm = toCm({
        feet: parseInt(heightInputF.val()),
        inches: parseInt(heightInputI.val()),
      });
      heightInputM.val(cm);

      var lbs = (weightValue / 2.20462262).toFixed(0);
      weightInput.val(lbs);
    } else {
      $('#heightfit').show();
      $('#heightcms').hide();
      $('#weightmeasure').html('lbs');

      $('#cm-system-wrapper .btn-primary').toggleClass('active');

      var heightValue = parseInt(heightInputM.val());
      var r = toFt(heightValue);

      heightInputF.val(r.feet);
      heightInputI.val(r.inches);

      var lbs = (weightValue * 2.20462262).toFixed(0);
      weightInput.val(lbs);
    }
  });

/* MagnetiCat Edit */
$('input[name=\'cm-iifym-protein-other\']').focus(function() {
  $('input:radio[name="cm-iifym-protein"][value="other"]').prop('checked', true);
});
$('input[name=\'cm-iifym-fat-other\']').focus(function() {
  $('input:radio[name="cm-iifym-fat"][value="other"]').prop('checked', true);
});
$('input:radio[name=\'dm-gender\']').change(function() {
  var gender = $('input:radio[name=dm-gender]:checked').val();
  if (gender == 'F') {
    $('input:radio[name="cm-iifym-fat"][value=".40"]').prop('checked', true);
  } else {
    $('input:radio[name="cm-iifym-fat"][value=".40"]').prop('checked', true);
  }
});
$('input[name=\'txtBF\']').change(function() {
  if ($('input:radio[name=\'formula\']:checked').val() == 'L') {
    var bodyfat = $('input[name=\'txtBF\']').val();
    if (bodyfat > 15) {
      $('input:radio[name="cm-iifym-protein"][value="1.25"]').prop('checked', true);
    } else {
      $('input:radio[name="cm-iifym-protein"][value="1.15"]').prop('checked', true);
    }
  }
});
$('input:radio[name=\'formula\']').change(function() {
  var leanmass_text = 'grams per lb. of lean mass';
  var mifflin_text = 'grams per lb. of body weight';
  var formula = $('input:radio[name=\'formula\']:checked').val();
  $('span[class=\'gramsperlb\']').each(function(index) {
    if (formula == 'L') {
      $(this).text(leanmass_text);
    } else {
      $(this).text(mifflin_text);
    }
  });
});
/* End MagnetiCat Edit */

$('#cm-meals-per-day').change(function() {
  cm_calc();
});

$('.cm-calories-fat-loss').click(function() {
  $('#cm-calories-fat-loss-text').html($(this).val());
});
$('.cm-calories-bulking').click(function() {
  $('#cm-calories-bulking-text').html($(this).val());
});
$('input[name=\'formula\']').click(function() {
  if ($('input[name=\'formula\']:checked').val() == 'A') {
    $('#activity-level').show();
    $('#exercise-level').hide();
  } else {
    $('#activity-level').hide();
    $('#exercise-level').show();
  }
});
$('.jk-tdee-input').on('keyup', function() {
  mins = $(this).val().replace(/[^\d.]/g, '');
  if (mins == '') {
    $(this).val('0');
    mins = 0;
  } else {
    $(this).val(parseInt(mins));
  }

  very_light = parseInt($('input[name=\'jk-tdee-very-light\']').val());
  light = parseInt($('input[name=\'jk-tdee-light\']').val());
  moderate = parseInt($('input[name=\'jk-tdee-moderate\']').val());
  heavy = parseInt($('input[name=\'jk-tdee-heavy\']').val());
  very_heavy = parseInt($('input[name=\'jk-tdee-very-heavy\']').val());

  sleeping = 1440 - very_light - light - moderate - heavy - very_heavy;

  if (sleeping < 0) {
    alert('You must not exceed 1440 minutes.');
    sleeping = parseInt(sleeping) + parseInt(mins);
    $(this).val(sleeping);
    sleeping = 0;
  }
  $('input[name=\'jk-tdee-sleeping\']').val(sleeping);
});

function cm_calc_calories()
{
  var result = 0,
  gender = $('input[name=\'dm-gender\']:checked').val(),
  age = parseInt($('input[name=\'dm-age\']').val()),
  heightInputM = $('#cmsheightvalue'),
  heightInputF = $('#heightvalue'),
  heightInputI = $('#heightinvalue'),
  weightValue = parseInt($('#weightvalue').val());

  if ($('input[name=\'cm-system\']:checked').val() === 'metric') {
    height = parseInt(heightInputM.val() * 100) / 100;
    weight = parseInt(weightValue * 100) / 100;
    weight_lbs = weight * 2.2;
  } else {
height = Math.round(((parseInt(heightInputF.val()) * 12) + parseInt(heightInputI.val())) * 2.54); //multiply by 2.54 to get cm
weight = Math.round(weightValue / 2.2); //divide by 2.2 for kilos from pounds
weight_lbs = weightValue;
}

// input validation

// if (!gender) {
//     $('#gendererror').css('display', 'block');
//     return false;
// } else {
//     $('#gendererror').css('display', 'none');
// }
var boxCounter = 0;

if (!age) {
  $('#age-form-group').addClass('invalid');
  boxCounter++;
} 
if (!weight){
  $('#weight-form-group').addClass('invalid');
  boxCounter++;
}
if (!height){
  $('#height-form-group').addClass('invalid');
  boxCounter++;
}

if ($('#excerciseweek').val() == ""){
  $('.exercise-week-group').addClass('invalid');
  boxCounter++;
}

if ($('#excerciseminuteweek').val() == ""){
  $('.exercise-minutes-group').addClass('invalid');
  boxCounter++;
}


if ($("#activities").val() === ""){
  $('.activities-dropdown-container').addClass('invalid');
  boxCounter++;
}

if ($("#exercise").val() === ""){
  $('.exercise-dropdown-container').addClass('invalid');
  boxCounter++;
}

if(boxCounter > 0){
  alert('Please complete all required fields.')
  $('html,body').animate({
    scrollTop: $("#form").offset().top},
    'slow');
  return false;
}

var normaldaily = parseFloat($('select[name=\'normaldailyactivity\'] option:selected').val());
var perweekexercise = parseInt($('#excerciseweek').val());
var perminutesexercise = parseInt($('#excerciseminuteweek').val());
var intenseexercise = parseFloat($('select[name=\'intenseexercise\'] option:selected').val());

if (!normaldaily) {
  normaldaily = 0;
}
if (!perweekexercise) {
  perweekexercise = 0;
}
if (!perminutesexercise) {
  perminutesexercise = 0;
}
if (!intenseexercise) {
  intenseexercise = 0;
}

var rockBottom = (weight * 2.2) * 8;
var maintain = 0;
var activity = 0;
activity = $('#cm-activity').val();
var BasalEnergyExpenditure = 0;
var very_light = 0;
var light = 0;
var moderate = 0;
var heavy = 0;
var very_heavy = 0;
var wake = 0;
var sleep = 0;

formula = $('input[name=\'formula\']:checked').val();
switch (formula) {
  case 'M':
  if (gender === 'M') {
    result = 5 + (10 * weight) + (6.25 * height) - (5 * age);
  } else {
    result = -161 + (10 * weight) + (6.25 * height) - (5 * age);
  }
  break;

  case 'L':
  var bodyfat = parseFloat($('input[name=\'txtBF\']').val());
  if (!bodyfat) {
    $('#txtBF').addClass('invalid');
    alert('Current body fat is required!');
// $('html,body').animate({
//     scrollTop: $("#txtBF").offset().top},
//     'slow');
return false;
}
leanMass = weight - (weight * bodyfat / 100);
leanMass_lbs = leanMass * 2.2;
result = 21.6 * leanMass + 370;
break;

case 'H':
if (gender === 'M') {
  result = 66.5 + (13.75 * weight) + (5.003 * height) - (6.775 * age);
} else {
  result = 655.1 + (9.563 * weight) + (1.85 * height) - (4.676 * age);
}
break;

case 'A':
if (parseInt($('input[name=\'jk-tdee-very-light\']').val()) === 'NaN') {
  $('input[name=\'jk-tdee-very-light\']').val('0');
}
if (parseInt($('input[name=\'jk-tdee-light\']').val()) === 'NaN') {
  $('input[name=\'jk-tdee-light\']').val('0');
}
if (parseInt($('input[name=\'jk-tdee-moderate\']').val()) === 'NaN') {
  $('input[name=\'jk-tdee-moderate\']').val('0');
}
if (parseInt($('input[name=\'jk-tdee-heavy\']').val()) === 'NaN') {
  $('input[name=\'jk-tdee-heavy\']').val('0');
}
if (parseInt($('input[name=\'jk-tdee-very-heavy\']').val()) === 'NaN') {
  $('input[name=\'jk-tdee-very-heavy\']').val('0');
}
if ($('input[name=\'jk-tdee-very-light\']').val() === '') {
  $('input[name=\'jk-tdee-very-light\']').val('0');
}
if ($('input[name=\'jk-tdee-light\']').val() === '') {
  $('input[name=\'jk-tdee-light\']').val('0');
}
if ($('input[name=\'jk-tdee-moderate\']').val() === '') {
  $('input[name=\'jk-tdee-moderate\']').val('0');
}
if ($('input[name=\'jk-tdee-heavy\']').val() === '') {
  $('input[name=\'jk-tdee-heavy\']').val('0');
}
if ($('input[name=\'jk-tdee-very-heavy\']').val() === '') {
  $('input[name=\'jk-tdee-very-heavy\']').val('0');
}

if (gender === 'M') {
  BasalEnergyExpenditure = Math.round(66.5 + (13.75 * weight) + (5.003 * height) - (6.775 * age));
  very_light = Math.round((BasalEnergyExpenditure * 1.4 / 1440) * parseInt($('input[name=\'jk-tdee-very-light\']').val()));
  light = Math.round((BasalEnergyExpenditure * 2.5 / 1440) * parseInt($('input[name=\'jk-tdee-light\']').val()));
  moderate = Math.round((BasalEnergyExpenditure * 4.2 / 1440) * parseInt($('input[name=\'jk-tdee-moderate\']').val()));
  heavy = Math.round((BasalEnergyExpenditure * 8.2 / 1440) * parseInt($('input[name=\'jk-tdee-heavy\']').val()));
  very_heavy = Math.round((BasalEnergyExpenditure * 12 / 1440) * parseInt($('input[name=\'jk-tdee-very-heavy\']').val()));
//alert(very_light+" "+light+" "+moderate+" "+heavy+" "+very_heavy);
} else {
  BasalEnergyExpenditure = Math.round(655 + (weight * 9.563) + (1.85 * height) - (4.676 * age));
  very_light = Math.round((BasalEnergyExpenditure * 1.4 / 1440) * parseInt($('input[name=\'jk-tdee-very-light\']').val()));
  light = Math.round((BasalEnergyExpenditure * 2.5 / 1440) * parseInt($('input[name=\'jk-tdee-light\']').val()));
  moderate = Math.round((BasalEnergyExpenditure * 2.5 / 1440) * parseInt($('input[name=\'jk-tdee-moderate\']').val()));
  heavy = Math.round((BasalEnergyExpenditure * 2.5 / 1440) * parseInt($('input[name=\'jk-tdee-heavy\']').val()));
  very_heavy = Math.round((BasalEnergyExpenditure * 2.5 / 1440) * parseInt($('input[name=\'jk-tdee-very-heavy\']').val()));
}

wake = very_light + light + moderate + heavy + very_heavy;
sleep = Math.round((BasalEnergyExpenditure / 1440) * (1440 - parseInt($('input[name=\'jk-tdee-very-light\']').val()) - parseInt($('input[name=\'jk-tdee-light\']').val()) - parseInt($(
  'input[name=\'jk-tdee-moderate\']').val()) - parseInt($('input[name=\'jk-tdee-heavy\']').val()) - parseInt($('input[name=\'jk-tdee-very-heavy\']').val())));
result = Math.round((sleep * 1) + (wake * 1));
activity = 1;
break;
}

maintain = result * activity;
maintain = Math.round(maintain);
// MagnetiCat Edit
var printBMR = result;
printBMR = Math.round(printBMR);
//console.log(printBMR);

var normaldailycalc = normaldaily * printBMR;
var dailycalorieavg = (perweekexercise * perminutesexercise * intenseexercise) / 7;
var TDEE = Math.round(normaldailycalc + dailycalorieavg);
//console.log(printBMR+' '+normaldaily+' '+perweekexercise+' '+intenseexercise+' Normal: '+normaldailycalc);
//printBMR=Math.round(BMR);
maintain = TDEE;
var loseFat = maintain - (maintain * 0.2);
var loseFat15 = maintain - (maintain * 0.15);
var loseFat20 = maintain - (maintain * 0.20);
var loseFat25 = maintain - (maintain * 0.25);
if (loseFat < rockBottom && rockBottom <= maintain) {
  loseFat = rockBottom;
}
if (loseFat15 < rockBottom && rockBottom <= maintain) {
  loseFat15 = rockBottom;
}
if (loseFat20 < rockBottom && rockBottom <= maintain) {
  loseFat20 = rockBottom;
}
if (loseFat25 < rockBottom && rockBottom <= maintain) {
  loseFat25 = rockBottom;
}
loseFat = Math.round(loseFat);
loseFat15 = Math.round(loseFat15);
loseFat20 = Math.round(loseFat20);
loseFat25 = Math.round(loseFat25);

var bulking = maintain * 1.10;
var bulking5 = maintain * 1.05;
var bulking10 = maintain * 1.10;
var bulking15 = maintain * 1.15;
if (bulking < rockBottom && rockBottom <= maintain) {
  bulking = rockBottom;
}
if (bulking5 < rockBottom && rockBottom <= maintain) {
  bulking5 = rockBottom;
}
if (bulking10 < rockBottom && rockBottom <= maintain) {
  bulking10 = rockBottom;
}
if (bulking15 < rockBottom && rockBottom <= maintain) {
  bulking15 = rockBottom;
}
bulking = Math.round(bulking);
bulking5 = Math.round(bulking5);
bulking10 = Math.round(bulking10);
bulking15 = Math.round(bulking15);


$('#cm-calories-fat-loss-text').html(loseFat);
$('#cm-calories-fat-loss15').val(loseFat15);
$('#cm-calories-fat-loss20').val(loseFat20);
$('#cm-calories-fat-loss25').val(loseFat25);
$('#cm-calories-maintenance').val(maintain);
$('#cm-calories-maintenance-text').html(maintain);
$('#cm-calories-bulking-text').html(bulking);
$('#cm-calories-bulking5').val(bulking5);
$('#cm-calories-bulking10').val(bulking10);
$('#cm-calories-bulking15').val(bulking15);
$('#cm-result-tdee .cm-result-box-value').html(TDEE);

// MagnetiCat Edit
$('#cm-result-bmr .cm-result-box-value').html(printBMR);
$('#results').show();


}

$('input[name=\'cm-calories\']').click(function() {
  $('#cm-step-3 .cm-macro-disable').hide();
});

$('.cm-button-calories').click(function(e) {
  e.preventDefault();
  cm_calc_calories();
});

//validation - remove class invalid 
$('#agevalue').keyup(function() {
  $('#age-form-group').removeClass('invalid');   
});

$('#weightvalue').keyup(function() {
  $('#weight-form-group').removeClass('invalid'); 
});

$('#heightvalue, #cmsheightvalue').keyup(function() {
  $('#height-form-group').removeClass('invalid'); 
});

$('#excerciseweek').keyup(function() {
  $('.exercise-week-group ').removeClass('invalid');
});

$('#excerciseminuteweek').keyup(function() {
  $('.exercise-minutes-group ').removeClass('invalid'); 
});

$('#fat-box').keyup(function() {
  $('#txtBF ').removeClass('invalid'); 
});
//validation - remove class invalid 

$('#cm-ratios').change(function() {
  cdr_name = $('option:selected', this).attr('data-name');
  if (cdr_name == 'iifym') {
    $('#cm-carbs').val('--').prop('disabled', true);
    $('#cm-protein').val('--').prop('disabled', true);
    $('#cm-fat').val('--').prop('disabled', true);
    $('.iifym-no-show').hide();
    $('.iifym-show').show();
  } else {
    $('#cm-carbs').val($('option:selected', this).attr('data-carbs')).prop('disabled', false);
    $('#cm-protein').val($('option:selected', this).attr('data-protein')).prop('disabled', false);
    $('#cm-fat').val($('option:selected', this).attr('data-fat')).prop('disabled', false);
    $('.iifym-no-show').show();
    $('.iifym-show').hide();
  }
});

function cm_calc()
{
  cm_calc_calories();
  cdr_name = $('#cm-ratios option:selected').attr('data-name');
  cdr_name = 'very-low-carb';
  total_calories = parseInt($('input[name=\'customCalorieAdjustment\']').val()) / 5 * 100 + 1530;

  carbs = 6;
  protein = 21;
  fat = 73;


// macro validation
var boxCounter = 0;

if ($('#agevalue').val() == "") {
  $('#age-form-group').addClass('invalid');
  boxCounter++;
} 
if ($('#weightvalue').val() == ""){
  $('#weight-form-group').addClass('invalid');
  boxCounter++;
}


if ($('#excerciseweek').val() == ""){
  $('.exercise-week-group').addClass('invalid');
  boxCounter++;
}

if ($('#excerciseminuteweek').val() == ""){
  $('.exercise-minutes-group').addClass('invalid');
  boxCounter++;
}


if ($("#activities").val() === ""){
  $('.activities-dropdown-container').addClass('invalid');
  boxCounter++;
}

if ($("#exercise").val() === ""){
  $('.exercise-dropdown-container').addClass('invalid');
  boxCounter++;
}

if(boxCounter > 0){
// alert('Please complete all required fields.')
return false;
}
// macro validation

if (carbs + protein + fat != 100) {
//Total is not 100%
//alert("Your carbohydrate, protein and fat percentages must add up to 100");
jQuery('#carboerror').html('Your carbohydrate, protein and fat percentages must add up to 100.');
} else {
  carbs = total_calories * carbs / 100;
  protein = total_calories * protein / 100;
  fat = total_calories * fat / 100;
  calories = {
    'day': {
      'carbs': carbs,
      'protein': protein,
      'fat': fat,
    },
    'one': {
      'carbs': carbs / 1,
      'protein': protein / 1,
      'fat': fat / 1,
    },
    'two': {
      'carbs': carbs / 2,
      'protein': protein / 2,
      'fat': fat / 2,
    },
    'three': {
      'carbs': carbs / 3,
      'protein': protein / 3,
      'fat': fat / 3,
    },
    'four': {
      'carbs': carbs / 4,
      'protein': protein / 4,
      'fat': fat / 4,
    },
    'five': {
      'carbs': carbs / 5,
      'protein': protein / 5,
      'fat': fat / 5,
    },
    'six': {
      'carbs': carbs / 6,
      'protein': protein / 6,
      'fat': fat / 6,
    },
    'seven': {
      'carbs': carbs / 7,
      'protein': protein / 7,
      'fat': fat / 7,
    },
  };
  grams = {
    'day': {
      'carbs': calories.day.carbs / 4,
      'protein': calories.day.protein / 4,
      'fat': calories.day.fat / 9,
      'divisor': 1,
    },
    'one': {
      'carbs': calories.one.carbs / 4,
      'protein': calories.one.protein / 4,
      'fat': calories.one.fat / 9,
      'divisor': 1,
    },
    'two': {
      'carbs': calories.two.carbs / 4,
      'protein': calories.two.protein / 4,
      'fat': calories.two.fat / 9,
      'divisor': 2,
    },
    'three': {
      'carbs': calories.three.carbs / 4,
      'protein': calories.three.protein / 4,
      'fat': calories.three.fat / 9,
      'divisor': 3,
    },
    'four': {
      'carbs': calories.four.carbs / 4,
      'protein': calories.four.protein / 4,
      'fat': calories.four.fat / 9,
      'divisor': 4,
    },
    'five': {
      'carbs': calories.five.carbs / 4,
      'protein': calories.five.protein / 4,
      'fat': calories.five.fat / 9,
      'divisor': 5,
    },
    'six': {
      'carbs': calories.six.carbs / 4,
      'protein': calories.six.protein / 4,
      'fat': calories.six.fat / 9,
      'divisor': 6,
    },
    'seven': {
      'carbs': calories.seven.carbs / 4,
      'protein': calories.seven.protein / 4,
      'fat': calories.seven.fat / 9,
      'divisor': 7,
    },
  };

}
meals = $('#cm-meals-per-day').val();

$('#cm-carbs-grams-day').html(Math.round(grams.day.carbs * 10) / 10);
$('#cm-protein-grams-day').html(Math.round(grams.day.protein * 10) / 10);
$('#cm-fat-grams-day').html(Math.round(grams.day.fat * 10) / 10);

$('#cm-carbs-cals-day').html(Math.round(calories.day.carbs));
$('#cm-protein-cals-day').html(Math.round(calories.day.protein));
$('#cm-fat-cals-day').html(Math.round(calories.day.fat));
$('#cm-total-cals-day').html(Math.round(calories.day.carbs + calories.day.protein + calories.day.fat));

$('#cm-carbs-grams-meal').html(Math.round(grams[meals].carbs * 10) / 10);
$('#cm-protein-grams-meal').html(Math.round(grams[meals].protein * 10) / 10);
$('#cm-fat-grams-meal').html(Math.round(grams[meals].fat * 10) / 10);

$('#cm-carbs-cals-meal').html(Math.round(calories[meals].carbs));
$('#cm-protein-cals-meal').html(Math.round(calories[meals].protein));
$('#cm-fat-cals-meal').html(Math.round(calories[meals].fat));
$('#cm-total-cals-meal').html(Math.round(calories[meals].carbs + calories[meals].protein + calories[meals].fat));

var progressObj = $('.fat_result-per-day');
var counterObj = $('#fat_day_counter');
progressObj.css("width", (Math.round(grams.day.fat * 10) / 10 * 100 /300)+'%');//original formula + progress bar % width
counterObj.text(Math.round(grams.day.fat * 10) / 10);//original formula
progressObj = $('.protein_result-per-day');
counterObj = $('#protein_day_counter');
progressObj.css("width",(Math.round(grams.day.protein * 10) / 10 * 100 / 200)+'%');//original formula + progress bar % width
counterObj.text(Math.round(grams.day.protein * 10) / 10);//original formula
progressObj = $('.carbs_result-per-day');
counterObj = $('#carbs_day_counter');
progressObj.css("width",(Math.round(grams.day.carbs * 10) / 10 * 100 / 500)+'%');//original formula + progress bar % width
counterObj.text((Math.round(grams.day.carbs * 10) / 10).toFixed(1));//original formula
progressObj = $('.calories_result-per-day');
counterObj = $('#calories_day_counter');
progressObj.css("width",((Math.round(calories.day.carbs + calories.day.protein + calories.day.fat)) * 100 / 5000)+'%');//original formula + progress bar % width
counterObj.text(Math.round(calories.day.carbs + calories.day.protein + calories.day.fat));//original formula
/**/
var progressObj_m = $('.fat_result-per-meal');
var counterObj = $('#fat_meal_counter');
progressObj_m.css("width",(Math.round(grams[meals].fat * 10) / 10 * 100 / 200)+'%');//original formula + progress bar % width
counterObj.text(Math.round(grams[meals].fat * 10) / 10);//original formula
progressObj_m = $('.protein_result-per-meal');
counterObj = $('#protein_meal_counter');
progressObj_m.css("width",(Math.round(grams[meals].protein * 10) / 10 * 100 / 100)+'%');//original formula + progress bar % width
counterObj.text(Math.round(grams[meals].protein * 10) / 10);//original formula
progressObj_m = $('.carbs_result-per-meal');
counterObj = $('#carbs_meal_counter');
progressObj_m.css("width",(Math.round(grams[meals].carbs * 10) / 10 * 100 / 500)+'%');//original formula + progress bar % width
counterObj.text((Math.round(grams[meals].carbs * 10) / 10).toFixed(1));//original formula
progressObj_m = $('.calories_result-per-meal');
counterObj = $('#calories_meal_counter');
progressObj_m.css("width",((Math.round(calories[meals].carbs + calories[meals].protein + calories[meals].fat)) * 100 / 5000)+'%');//original formula + progress bar % width
counterObj.text(Math.round(calories[meals].carbs + calories[meals].protein + calories[meals].fat));//original formula

var fiber_low = Math.round(weight_lbs * 0.2);
var fiber_high = Math.round(weight_lbs * 0.25);
$('#cm-fiber-grams-day').html(fiber_low + ' - ' + fiber_high);

fiber_low = fiber_low / parseInt(grams[meals].divisor);
fiber_high = fiber_high / parseInt(grams[meals].divisor);
$('#cm-fiber-grams-meal').html(Math.round(fiber_low) + ' - ' + Math.round(fiber_high));
/**/
$('#cm-step-4 .cm-macro-disable').hide();
}

$('.cm-calc-button').click(function() {
  jQuery('#carboerror').html('');
  cm_calc();
});

function toFt(n)
{
  var realFeet = ((n * 0.393700) / 12);
  var feet = Math.floor(realFeet);
  var inches = Math.round((realFeet - feet) * 12);
  return {
    feet: feet,
    inches: inches,
  };
}

function toCm(n)
{
  var inches = Math.round(n.feet * 12);
  inches = Math.round(inches + n.inches);
  return Math.round((inches * 2.54).toFixed(2));
}
});

function isNumeric(num, fieldPrompt, fieldName)
{
  var regTest = /(^\d+$)|(^\d+\.\d+$)/;
  if (regTest.test(num)) {
    return true;
  } else {
    if (fieldPrompt) {
      alert(fieldPrompt + ' Please enter numbers only.');
      Get(fieldName).focus();
      Get(fieldName).select();
    }
    return false;
  }
}

jQuery(document).ready(function() {
  var $range = jQuery('input[name=\'customCalorieAdjustment\']');

  $('.tect_blow .irs-single').attr('data-toggle', 'tooltip');
  $('.tect_blow .irs-single').attr('data-placement', 'top');
  $('.tect_blow .irs-single').attr('title', 'This is a balanced calorie intake');

  $('input[name="customCalorieAdjustment"]').change(function() {
    console.log($(this).val());

// $('#rangeVal').text($(this).val());

var slider_val = parseInt($(this).val());
if (slider_val > -51 && slider_val < -34) {
  $('.tect_blow .irs-single').attr('data-original-title', 'This is an extremely risky calorie deficit. It can lead to metabolic damage in the long run');
} else {
  if (slider_val > -35 && slider_val < -4) {
    $('.tect_blow .irs-single').attr('data-original-title', 'This is a risky calorie deficit');
  } else {
    if (slider_val == 0) {
      $('.tect_blow .irs-single').attr('data-original-title', 'This is a balanced calorie intake');
    } else {
      if (slider_val > 0 && slider_val <= 35) {
        $('.tect_blow .irs-single').attr('data-original-title', 'This is a risky calorie surplus');
      } else {
        if (slider_val > 36 && slider_val <= 50) {
          $('.tect_blow .irs-single').attr('data-original-title', 'This is an extremely risky calorie surplus. It can lead to metabolic damage in the long run');
        }
      }
    }
  }
}
});


jQuery('#cm-ratios, #cm-fat, #cm-carbs, #cm-protein').click(function() {
  jQuery('.cm-calc-button').trigger('click');
});

jQuery('select[name="normaldailyactivity"], select[name="intenseexercise"], input[name="formula"], .calccontainer input[type="radio"]').click(function() {
//callevent();
});

function callevent()
{
  jQuery('.cm-button-calories').trigger('click');
  jQuery('.cm-calc-button').trigger('click');
};

});

function formatCurrency(strValue)
{
  strValue = strValue.toString().replace(/\$|\,/g, '');
  dblValue = parseFloat(strValue);
  blnSign = (dblValue == (dblValue = Math.abs(dblValue)));
  dblValue = Math.floor(dblValue * 100 + 0.50000000001);
  intCents = dblValue % 100;

  if (intCents >= 50) {
    dblValue = dblValue + 100;
  }

  strCents = intCents.toString();
  dblValue = Math.floor(dblValue / 100).toString();

  if (intCents < 10) {
    strCents = '0' + strCents;
  }

  for (var i = 0; i < Math.floor((dblValue.length - (1 + i)) / 3); i++) {
    dblValue = dblValue.substring(0, dblValue.length - (4 * i + 3)) + ',' +

    dblValue.substring(dblValue.length - (4 * i + 3));
  }

  return (((blnSign) ? '' : '-') + dblValue + '.' + strCents);
}
// END CALCULATOR PAGE
/*end custom.js from Shopify*/

}
},

'keto_food_list': {
  init: function() {
//move the elements to the end of DOM
$('#field_2_33, #field_2_34, #field_2_35').appendTo('#gform_wrapper_2 .gform_body');
}
},
'tax_recipes_category': {
  init: function() {


    function myFunction(x) {
  if (x.matches) { // If media query matches

  } else {
   /*begin sticky nav*/
   var sidebar = new StickySidebar('#bottom #box', {
    containerSelector: '#bottom .articles',
    innerWrapperSelector: '#bottom #filter-box',
    topSpacing: 0,
    bottomSpacing: 0
  });
   /*end sticky nav*/
 }
}

var x = window.matchMedia("(max-width: 767px)");
myFunction(x); // Call listener function at run time
x.addListener(myFunction); // Attach listener function on state changes
}
},
'post_type_archive_recipescentre': {
  init: function() {

   function myFunction(x) {
  if (x.matches) { // If media query matches

  } else {
   /*begin sticky nav*/
   var sidebar = new StickySidebar('#bottom #box', {
    containerSelector: '#bottom #response',
    innerWrapperSelector: '#bottom #filter-box',
    topSpacing: 0,
    bottomSpacing: 0
  });
   /*end sticky nav*/
 }
}

var x = window.matchMedia("(max-width: 767px)");
myFunction(x); // Call listener function at run time
x.addListener(myFunction); // Attach listener function on state changes

}
},
'page_template_template_guides':{
  init: function() {
  }

},
'archive': {
  init: function() {

    function myFunctionCollapse(x) {
      if (x.matches) { 

        $("#bottom .btn-lg.btn-block").click(function(){
          $("#collapseFilters").collapse('toggle');
          $(".collapse").on("show.bs.collapse", function(){
           $(this).prev(".card-title").find(".fa").removeClass("fa-plus").addClass("fa-times");
         }).on("hide.bs.collapse", function(){
          $(this).prev(".card-title").find(".fa").removeClass("fa-times").addClass("fa-plus");
        });
       });

      } else {
      }
    }

    var x = window.matchMedia("(max-width: 991.98px)");
    myFunctionCollapse(x); 
    x.addListener(myFunctionCollapse); 

  },
  finalize: function() {
  }
},
'ketocademy': {
  init: function() {

    function myFunction(x) {
  if (x.matches) { // If media query matches

    $('.carousel').flickity({
  // options
  groupCells: false,
  pageDots: true,
  arrowShape: false
});

  } else {

    $('.carousel').flickity({
  // options
  groupCells: true,
  contain: true,
  pageDots: true,
  arrowShape: false
});


  }
}

var x = window.matchMedia("(max-width: 767px)");
myFunction(x); // Call listener function at run time
x.addListener(myFunction); // Attach listener function on state changes


}
}
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
  fire: function(func, funcname, args) {
    var fire;
    var namespace = Sage;
    funcname = (funcname === undefined) ? 'init' : funcname;
    fire = func !== '';
    fire = fire && namespace[func];
    fire = fire && typeof namespace[func][funcname] === 'function';

    if (fire) {
      namespace[func][funcname](args);
    }
  },
  loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

// Load Events
$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.